import { CheckCircle2, Loader2, XCircle } from 'lucide-react'
import { useEffect, useState } from 'react'

import {
  ComplianceComponents,
  useComplianceClient
} from '@/api/compliance-client'

type Health = ComplianceComponents.Schemas.Health
type HealthState =
  | { status: 'loading' }
  | { status: 'ok'; payload: Health }
  | { status: 'error'; message: string }

export default function ComplianceOverview() {
  const client = useComplianceClient()
  const [health, setHealth] = useState<HealthState>({ status: 'loading' })

  useEffect(() => {
    client
      .health()
      .then((res) => setHealth({ status: 'ok', payload: res.data }))
      .catch((err) =>
        setHealth({
          status: 'error',
          message: err?.message ?? String(err)
        })
      )
  }, [client])

  return (
    <div className="w-full p-6">
      <h1 className="text-2xl font-semibold mb-2">Compliance Center</h1>
      <p className="text-muted-foreground mb-6">
        D0 foundation — sidebar + routes stubbed. Documents UI lands in D2. See{' '}
        <code>svc-compliance-api/docs/plan.md</code>.
      </p>

      <div className="rounded-md border p-4 max-w-md">
        <div className="text-sm font-medium mb-2">svc-compliance-api</div>
        {health.status === 'loading' && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" />
            Probing…
          </div>
        )}
        {health.status === 'ok' && (
          <div className="flex items-center gap-2 text-sm">
            <CheckCircle2 className="h-4 w-4 text-green-600" />
            <span>
              ok · stage <code>{health.payload.stage}</code> · commit{' '}
              <code>{health.payload.commit}</code>
            </span>
          </div>
        )}
        {health.status === 'error' && (
          <div className="flex items-center gap-2 text-sm text-destructive">
            <XCircle className="h-4 w-4" />
            <span>{health.message}</span>
          </div>
        )}
      </div>
    </div>
  )
}
